// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[link-classes=google-translate].dropdown-item[data-v-f7e21810]:focus,[link-classes=google-translate].dropdown-item[data-v-f7e21810]:hover{color:inherit;text-decoration:none;background:#fff}.actor[data-v-f7e21810]{padding:.25rem 1.2rem;color:inherit}.actor span[data-v-f7e21810]{margin:0;display:block}.actor .name[data-v-f7e21810]{font-weight:700}.actor .email[data-v-f7e21810]{font-weight:400;font-size:.9em}", ""]);
// Exports
module.exports = exports;
